import { Informations } from "../../globaltypes";
import { SERVICES } from "../../data/constans";

const Services: React.FC = (): JSX.Element => {
  return (
    <div id="services" className="w-full scroll-mt-[8vh] bg-gradient-to-r from-blue-300 to-blue-500 pb-16 pt-8">
      <div className="text-center text-4xl font-extrabold text-white lg:text-5xl xl:text-6xl">Szolgáltatások</div>
      <div className="mx-auto mt-8 grid w-[90%] max-w-[1200px] grid-cols-1 items-center gap-16 md:grid-cols-2 xl:w-[80%] xl:grid-cols-3 xl:gap-20">
        {SERVICES.map((service, index) => (
          <div
            key={index}
            className="h-full min-h-[400px] rounded-lg bg-white shadow-lg shadow-blue-600 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-blue-700 lg:p-2 xl:p-3"
          >
            <div className="flex items-center justify-center">
              <img src={service.image} className="w-[40%]" />
            </div>

            <h2 className="py-2 text-center text-2xl font-extrabold text-blue-500">{service.name}</h2>
            <p className="p-6 text-justify text-sm font-light text-blue-500 md:text-justify lg:p-2">
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
